// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";

function PilotClozeDropBucketContainer(props) {
  return React.createElement(V3DndBehaviour$LiteracyplanetTupperware.Drop.make, {
              id: props.id,
              headerClassname: "pilotClozeBucketHeader PilotClozeDropBucketContainer",
              children: props.children
            });
}

var make = PilotClozeDropBucketContainer;

var $$default = PilotClozeDropBucketContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
